/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Import_Terms_FailedInputs */

const en_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to import terms: ${i?.error}`)
};

const fr_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’importation des termes : ${i?.error}`)
};

const de_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begriffe konnten nicht importiert werden: ${i?.error}`)
};

const it_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare i termini: ${i?.error}`)
};

const ru_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать термины: ${i?.error}`)
};

const es_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar términos: ${i?.error}`)
};

const zh_cn2_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入术语失败：${i?.error}`)
};

const ja_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用語のインポートに失敗しました: ${i?.error}`)
};

const hi_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शर्तें आयात करने में विफल: ${i?.error}`)
};

const pt_pt2_knp_terms_import_terms_failed = /** @type {(inputs: Knp_Terms_Import_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar os termos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to import terms: {error}" |
*
* @param {Knp_Terms_Import_Terms_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_terms_failed = /** @type {((inputs: Knp_Terms_Import_Terms_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_Terms_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_import_terms_failed(inputs)
	if (locale === "de") return de_knp_terms_import_terms_failed(inputs)
	if (locale === "it") return it_knp_terms_import_terms_failed(inputs)
	if (locale === "ru") return ru_knp_terms_import_terms_failed(inputs)
	if (locale === "es") return es_knp_terms_import_terms_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_import_terms_failed(inputs)
	if (locale === "ja") return ja_knp_terms_import_terms_failed(inputs)
	if (locale === "hi") return hi_knp_terms_import_terms_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_import_terms_failed(inputs)
	return en_knp_terms_import_terms_failed(inputs)
});